<template>
	<div>
		<div class="row">
			<div class="col-md-9">
				<div class="input-group">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<router-link class="btn btn-primary btn-block btn-lg mb-3" to="/settings/workbooks/item">
					{{ $t('new') }}
				</router-link>
			</div>
		</div>

		<InfiniteScroll
			scrollElementId="main"
			type="Table"
			:cols="[{ key: 'workbook_title', heading: $t('name'), size: 12 }]"
			breakpoint="sm"
			:dataUrl="`${$settings.APIBaseURL}/workbooks/list`"
			dataProperty="workbooks"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectItem"
			@deleteItem="deleteItem"
			:noResultsText="$t('no-results')"
			ref="infinitescroll"
			idProperty="workbook_id"
		/>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll
	},
	data() {
		return {
			search: {
				q: ""
			}
		};
	},
	mounted() {
		this.getList();
	},
	methods: {
		newSearch() {
			this.getList();
		},
		getList() {
			const body = {
				q: this.search.q ? this.search.q : ""
			};
			this.$refs.infinitescroll.getData("replace", body);
		},
		selectItem(item) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/settings/workbooks/item/${item.workbook_id}`);
		},
		deleteItem(item) {
			this.$cfetch(`${this.$settings.APIBaseURL}/workbooks/delete`, {
				data: {
					workbook_id: item.workbook_id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$refs.infinitescroll.removeItem(item);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		}
	},
	computed: {}
};
</script>
